import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_card = _resolveComponent("el-card");
  const _component_query_assets_modal = _resolveComponent("query-assets-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_card, {
    shadow: "never"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: _ctx.formData,
      ref: "form",
      size: "small",
      inline: true,
      "label-width": "100px",
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "投放运营位"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: _ctx.formData.positionId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.formData.positionId = $event),
              options: _ctx.posData,
              props: $setup.defaultProps,
              "show-all-levels": false,
              onChange: $setup.posChange,
              disabled: _ctx.opType === 'edit'
            }, null, 8, ["modelValue", "options", "props", "onChange", "disabled"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "投放素材选择",
            size: "medium"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              ref: "self",
              modelValue: _ctx.formData.assetsName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.formData.assetsName = $event),
              onFocus: _cache[2] || (_cache[2] = $event => {
                _ctx.modalShow = true;
                _ctx.$refs.self.blur();
              }),
              disabled: _ctx.assetDisabled || _ctx.opType === 'edit'
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "投放渠道选择"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              indeterminate: _ctx.isIndeterminate,
              modelValue: _ctx.checkAll,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.checkAll = $event),
              onChange: $setup.handleCheckAllChange
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("全选", -1)]))]),
              _: 1
            }, 8, ["indeterminate", "modelValue", "onChange"]), _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.checkedCities,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.checkedCities = $event),
              onChange: $setup.handleCheckedCitiesChange
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, city => {
                return _openBlock(), _createBlock(_component_el_checkbox, {
                  label: city.areaCode,
                  key: city.areaCode
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(city.areaName), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "投放有效期"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _ctx.dateRange,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.dateRange = $event),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              onChange: $setup.dateRangeChange,
              disabledDate: $setup.disabledDate,
              format: "YYYY-MM-DD HH:mm:ss",
              "default-time": _ctx.defaultTime
            }, null, 8, ["modelValue", "onChange", "disabledDate", "default-time"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "活动名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入活动名称",
              modelValue: _ctx.formData.actName,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.formData.actName = $event),
              disabled: _ctx.opType === 'edit'
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "是否必须投放"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: _ctx.isMustPut,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.isMustPut = $event),
              disabled: false,
              onChange: $setup.mustPutChange
            }, null, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "备注说明",
              modelValue: _ctx.formData.remark,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.formData.remark = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.onSubmit
    }, {
      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("确定投放", -1)]))]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_query_assets_modal, {
    id: _ctx.formData.positionId,
    show: _ctx.modalShow,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => _ctx.modalShow = $event),
    onChooseHandler: $setup.chooseHandler
  }, null, 8, ["id", "show", "onChooseHandler"])], 64);
}